// https://reactjs.org/docs/portals.html
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('modal-root') || document.getElementsByTagName('body')[0];

const Portal = (props) => {
  const modalDOMElement = document.createElement('div');

  modalRoot.appendChild(modalDOMElement);

  useEffect(() => {
    return () => modalRoot.removeChild(modalDOMElement);
  }, [modalDOMElement]);

  return ReactDOM.createPortal(props.children, modalDOMElement);
};

export default Portal;
